import type { ValidationErrors } from '../../../../../../utils/validation';
import type { IPilotDiagnosticReportCustomControlData } from './types';
import { translateKey } from '../../../../../../translate';
import { FormContextProvider } from '../../../../../elements/formContext';
import { RadioGroupField } from '../../../../../fields/RadioGroup';
import { TextAreaField } from '../../../../../fields/TextArea';

interface IPilotExaminationV1DiagnosticReportAddEditCustomControlFieldsProps {
    customControlData: IPilotDiagnosticReportCustomControlData;
    errors: ValidationErrors;
    handleChangeCustomControl: (values: Partial<IPilotDiagnosticReportCustomControlData>) => Promise<void>;
    validateOneCustomControl: (name: string) => Promise<void>;
}

export function PilotExaminationV1DiagnosticReportAddEditCustomControlFields(
    props: IPilotExaminationV1DiagnosticReportAddEditCustomControlFieldsProps
) {
    return (
        <>
            <FormContextProvider
                value={{
                    placeholderGroupName: 'customControlData',
                    item: props.customControlData,
                    errors: props.errors,
                    customControlData: true,
                    onChange: async (key, value) => await props.handleChangeCustomControl({ [key]: value }),
                    onDoValidate: async (key) => await props.validateOneCustomControl(key),
                }}
            >
                <RadioGroupField
                    fieldKey="afwijkend"
                    label="Afwijkend"
                    options={['Ja', 'Nee', 'Niet te beoordelen']}
                />

                <TextAreaField
                    fieldKey="werkdiagnose"
                    label={translateKey('diagnosticReport.workingDiagnosis')}
                    placeholder={translateKey('diagnosticReport.workingDiagnosis')}
                />

                <TextAreaField
                    fieldKey="toelichting_bevindingen"
                    label={translateKey('diagnosticReport.remarks')}
                    placeholder={translateKey('diagnosticReport.remarks')}
                />
            </FormContextProvider>
        </>
    );
}

// eslint-disable-next-line @stylistic/max-len
export function pilotExaminationV1DiagnosticReportInitializeCustomControlData(): IPilotDiagnosticReportCustomControlData {
    return {
        afwijkend: null,
        werkdiagnose: null,
        toelichting_bevindingen: null,
    };
}
